import { render } from "./SavedView.vue?vue&type=template&id=5a0474e2&scoped=true"
import script from "./SavedView.vue?vue&type=script&lang=js"
export * from "./SavedView.vue?vue&type=script&lang=js"

import "./SavedView.vue?vue&type=style&index=0&id=5a0474e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0474e2"]])

export default __exports__